// Trigger Group Search Table(2700423152)
/*
Sohel 09/27/2022 2700423152 Trigger Group Trigger group Client and Agency Type Changes
Sohel 09/29/2022 2700423152 Trigger Group Added Toast, validation and Event Trigger Changes
Sohel 09/30/2022 2700423152 Tabel Payload Changes
Sohel 10/10/2022 2700423152 Removed unused Code
Sohel 10/12/2022 2700423152 Trigger Group Added breadcrumbs,label changes,pagination changes
Dilip 10/12/2022 2700423152 search trigger group payload changed
Sohel 10/14/2022 2700423152 Trigger Group Added Comments
Raghu 27/10/2022 2700423152 Table Enhancements and Font size fixes
Ashraf  10/28/2022  2700423152 redirect to add trigger group on click of add trigger group button
Ashraf 10/30/2022 2700423152 fixed table pagination issue
Lalitha 10/31/2022 2700423152 Added clickable link functionality to group code
Lalitha 10/31/2022 2700423152 Removed unneccessary comments
lalitha 11/01/2022 2700423152 added span element in column link
saikrishna 11/03/2022 2700423152 changed the paginationOptions
Dilip 11/03/2022 2700423152 Added group code in delete popup
Sohel 11/03/2022 2700423152 label changes
Sohel 11/04/2022 2700423152 Access Method label changes
Sohel 11/04/2022 2699818958 Implement Run Batch Trigger Group Functionality
Sohel 11/05/2022 2699761741 rename tooltip.
Rajesh 11/18/2022 2699761741 added batch tirgger for night jobs.
Sohel 11/05/2022 2699761741 rename tooltip
Sohel 11/18/2022 2700423152 Payload Changes
akhila 11/18/2022 2700423152 passing trigger data to night jobs
Akhila 11/23/2022 2700423152 access type value changes
Akhila 11/25/2022 2700423152 table title name change
Rajesh 11/25/2022 2700423152 trigger execution action.
akhila 11/26/2022 2700423152 changed code and description titles
Rajesh 11/28/2022 2700423152 fixed history icon hidden for night jobs.
Rajesh 11/29/2022 2700423152 tooltip change
Ravi 11/29/2022 2700423152 MuiTable fixed action conditional rendering
Akhila 12/02/2022 2700423152 bugFix doubleLoader issue
Sohel  12/05/2022 2700423152 Added Edit Icon and border to code
akhila 12/08/2022 2700423152 added session storage for search items
Akhila 12/09/2022 2700423152 fixed session saerch issue
lalitha 12/09/2022 2700423152 Added Created Date column and payload
Raghu 12/12/2022  2700423152 Table Footer styling fixes
Akhila 12/13/2022 2700423152 bugFix session stoarge
Akhila 12/15/2022 2700423152 Added Role based access
Ashraf 12/21/2022 2700423152 fixed role access disable issue
sai krisna 12/27/2022 2700423152 add download Icon for download recored
Raghu 12/28/2022 2700423152 Button Text spelling fixes
Dilip 12/30/2022 2700423152 renamed labels for code and description
sai krisha 30/12/2022 2700423152 add code description values
Rohini 02/09/2023 2698964415 Added the new classname
Dilip 02/09/2023 2700430604 added  created by dropdown
Sohel 02/15/2023 2700430604 Added Last Step
Sohel 02/22/2023 2700430604 Fixed schedular reset issue
//Akhila 03/09/2023  2699234404 Added loader and download toast message
Suresh Peddavoora 03/15/2023 2699234404 Added Dropdown menu in Action Column in table
Suresh Peddavoora 03/16/2023 2699234404 Added test menu in Action Column in table
Akhila 03/17/2023 3225736869 bug fixed in scheduler add task report reusable component fix
Raghu 04/04/2023 3225736869 added add icon
Ravi 05/31/2023 3225736869 changed delete popup message
Akhila 06/08/2023 3225736869 created date change to date created field and column
Prakash 28/06/2023 3225736869 fixed ui bugs
Sohel 10/17/2023 3225736869 Fixed Role Access Disabled Issue
Sohel 10/26/2023 3225736869 Fixed pagebreak issue in scheduler  add task tab

*/

import React, {useState, useEffect, createRef} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination, Button} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {httpPaginationDelete, httpPaginationPost} from './../../../../util/Rest';
import {useDispatch} from 'react-redux';
import DeleteTableRecordPopup from './../../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import {ErrorSnackbar} from './../../../../components/CustomSnackBar/index';
import {SuccessSnackbar} from './../../../../components/CustomSnackBar/index';
import {
  fetchTriggerGroup,
  resetRunReport,
  triggerExecutions,
  setBatchTriggerCode,
  setBatchTriggersDraft,
  setBatchTriggersLastStep,
  resetConfigUrl,
  resetDockey,
} from '../../../../redux/reducers/TriggerGroup';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {makeStyles} from '@material-ui/core';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import {useSelector} from 'react-redux';
// import PageLoader from "../../../../components/PageLoader";
import DialogBox from '../../../../components/DialogBox';
import TriggerExecutionsTable from './TriggerExecutionsTable';
import moment from 'moment';
import {
  fetchCreatedByDropDownData,
  resetReportSchedule,
} from '../../../../redux/reducers/ReportMaster';
import {
  getClientCodeData,
  getCollectorsData,
  getDropDownData,
  getFieldCode,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import axios from 'axios';
import {resetDownloadMsg} from '../../../../redux/reducers/PreviewFileData';
import PageLoader from '../../../../components/PageLoader';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import AddIcon from '@material-ui/icons/AddOutlined';
export default function TriggerSearchTable({
  searchData,
  setSubmit,
  submit,
  setValue,
  setRunClicked,
  setRowData,
  nightJobSearchTrigger,
  setTriggerSearchCode,
  setSearchTrigger,
  seTriggerData,
  setRowSelected = () => {},
}) {
  const [arrayLast, setArrayLast] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [deleteData, setDeleteData] = useState({});
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [triggerExecution, setTriggerExecution] = useState(false);
  const [historyData, setHistoryData] = useState({});

  const {roleData} = useSelector(({role}) => role);
  const roleDataDisable = roleData?.window?.['Batch Triggers']?.BT;
  const {
    successMsg,
    errorMsg,
    runReportStatus,
    configurationUrl,
    dockey,
  } = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const tableRef = createRef();
  const dispatch = useDispatch();
  const useStyles = makeStyles((theme) => ({
    'link': {
      color: '#320469 !important',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();
  const {fieldCodeData} = useSelector(({addReportMaster}) => addReportMaster);
  const onEditCall = (rowData) => {
    dispatch(
      setBatchTriggerCode({
        property: 'groupCode',
        value: rowData.groupCode,
      }),
    );
    dispatch(
      setBatchTriggersDraft({
        property: 'isBatchTriggersDraft',
        value: rowData.isDraft,
      }),
    );
    dispatch(
      setBatchTriggersLastStep({
        property: 'lastStep',
        value: rowData.lastStep,
      }),
    );
  };
  const columns = [
    {
      title: 'Batch Trigger Name',
      field: 'groupCode',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            if (!nightJobSearchTrigger) {
              onEditCall(rowData);
              dispatch(fetchTriggerGroup(rowData?.triggerGroupId));
              setRowSelected(true);
              setValue(1);
            }
            if (nightJobSearchTrigger) {
              setTriggerSearchCode(rowData);
              setSearchTrigger(false);
              seTriggerData(rowData);
            }
          }}
        >
          {rowData?.groupCode ? rowData?.groupCode.replace(/ /g, '\u00a0') : ""}
        </span>
      ),
    },
    {
      title: 'Batch Trigger Description',
      field: 'groupDescription',
      render: (rowData) => (
        <>
          <div>
            {rowData.groupDescription ? rowData.groupDescription.replace(/ /g, '\u00a0') : ""}
          </div>
        </>
      ),
    },
    {
      title: 'Filter Method',
      field: 'accessType',
      render: (rowData) => {
        return fieldCodeData?.length > 0 ?
          fieldCodeData?.filter((item) => item?.fieldCode === rowData?.accessType)[0]?.description :
          null;
      },
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
  ];

  // based on submit update table data(2700423152)
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const [rows, setRows] = useState(defaultRows);

  // open delete popup and handle deleted data(2700423152)
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleEdit = (rowData) => {
    dispatch(fetchTriggerGroup(rowData?.triggerGroupId));
    setValue(1);
    onEditCall(rowData);
    setRowSelected(true);
  };
  const handleRun = (rowData) => {
    setRunClicked(true);
    setRowData(rowData);
  };
  const handleExecution = (rowData) => {
    setTriggerExecution(true);
    dispatch(triggerExecutions(rowData?.triggerGroupId));
    setHistoryData(rowData);
  };
  // closed delete popup(2700423152)
  const handleClose = () => {
    setIsDelete(false);
  };

  // reset delete toast message(2700423152)
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 3000);
    }
  }, [tstmsg, deleteErrorMsg]);

  // delete Trigger Group(2700423152)
  const handleSubmit = () => {
    httpPaginationDelete(`event/delete/triggergroup/${deleteData?.triggerGroupId}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // based on status Update table(2700423152)
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('batchtrigger'));
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (runReportStatus === 200) {
      setTimeout(() => {
        dispatch(resetRunReport());
        setRunClicked(false);
      }, 1500);
      setRunClicked(false);
    }
  }, [runReportStatus]);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetRunReport());
      }, 1500);
    }
  }, [successMsg, errorMsg, runReportStatus]);
  const handleTrigger = () => {
    setTriggerExecution(false);
  };
  useEffect(() => {
    dispatch(
      setBatchTriggerCode({
        property: 'groupCode',
        value: '',
      }),
    );
    dispatch(
      setBatchTriggersDraft({
        property: 'isBatchTriggersDraft',
        value: '',
      }),
    );
    dispatch(
      setBatchTriggersLastStep({
        property: 'lastStep',
        value: 0,
      }),
    );
    dispatch(resetReportSchedule());
  }, []);
  const searchSessionBatchTrigger = JSON.parse(sessionStorage.getItem('searchBatchTrigger'));
  if (searchSessionBatchTrigger && !submit && !nightJobSearchTrigger) {
    searchData = searchSessionBatchTrigger;
  }

  useEffect(() => {
    dispatch(getFieldCode());
    dispatch(getCollectorsData());
    dispatch(getDropDownData());
    dispatch(getClientCodeData());
    setRowSelected(false);
  }, []);

  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);

  return (
    <>
      <DialogBox
        open={triggerExecution}
        dialogClose={handleTrigger}
        title={`Trigger Executions `}
        maxWidth="lg"
        hideFooter={true}
      >
        <TriggerExecutionsTable historyData={historyData} />
      </DialogBox>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Trigger Maintenance'}
      />
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Batch Trigger"
        value={`Are you sure you want to delete the ${deleteData?.groupCode?.replace(/ /g, '\u00a0')} Batch Trigger?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12}>
        <div className={ !nightJobSearchTrigger ? 
          'custom-table global-field-table  custom-toolbar-icons custom-actions-icon new-standard-textfields actions-dropdown-table tablescroll-block' : 
          ' custom-table global-field-table  custom-toolbar-icons custom-actions-icon new-standard-textfields tablescroll-block'}>
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `event/search/allTrigger`;

                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  groupCode: searchData?.groupCode ? searchData?.groupCode : '',
                  groupType: searchData?.groupType ? searchData?.groupType?.value : '',
                  groupDescription: searchData?.description ? searchData?.description : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  accessType: searchData?.accessType?.fieldCode ?
                    searchData?.accessType?.fieldCode :
                    '',
                  orderDirection: query?.orderDirection,
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  search: query?.search ? query?.search : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleRun={handleRun}
                  handleExecution={handleExecution}
                  hiddenMenu={{
                    edit: false,
                    copy: true,
                    notes: true,
                    hiddenDelete: nightJobSearchTrigger,
                    execution: nightJobSearchTrigger,
                    run: nightJobSearchTrigger,
                    usage: true,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: roleDataDisable?.edit === false,
                    disableRun: roleDataDisable?.edit === false,
                    disableCopy: roleDataDisable?.add === false,
                    disableDelete: roleDataDisable?.delete === false,
                    disableUsage: false,
                    disableExecution: false,
                    disableNotes: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {!nightJobSearchTrigger && (
                      <Button
                        type="button"
                        variant="outlisetOpenned"
                        className={`mx-1 search-btn`}
                        disabled={roleDataDisable?.add === false}
                        isFreeAction={true}
                        onClick={() => {
                          setValue(1);
                          setRowSelected(false);
                        }}
                        startIcon={<AddIcon />}
                      >
                        Add Batch Trigger
                      </Button>
                    )}
                  </div>
                </div>
              ),
            }}
            localization={{
              header: {
                actions: nightJobSearchTrigger ? '' : 'Actions',
              },
            }}
            // actions={
            //   !nightJobSearchTrigger && [
            //     {
            //       icon: () => <EditOutlinedIcon />,
            //       tooltip: "Edit",
            //       disabled: roleDataDisable?.edit === false,
            //       onClick: (event, rowData) => {
            //         dispatch(fetchTriggerGroup(rowData?.groupCode));
            //         setValue(1);
            //         onEditCall(rowData);
            //       },
            //     },
            //     (rowData) => {
            //       return {
            //         icon: () => <PlayCircleOutlineIcon />,
            //         tooltip: rowData?.isDraft !== "Y" ? "Run" : "",
            //         disabled: roleDataDisable?.edit === false || rowData?.isDraft === "Y",
            //         hidden: nightJobSearchTrigger,
            //         onClick: (event, rowData) => {
            //           setRunClicked(true);
            //           setRowData(rowData);
            //         },
            //       };
            //     },
            //     (rowData) => {
            //       return {
            //         icon: () => (
            //           <>
            //             <DeleteOutlineOutlinedIcon />
            //           </>
            //         ),
            //         tooltip: "Delete",
            //         hidden: nightJobSearchTrigger,
            //         disabled: roleDataDisable?.delete === false,
            //         onClick: () => {
            //           handleDelete(rowData);
            //         },
            //       };
            //     },
            //     {
            //       icon: () => <HistoryIcon />,
            //       hidden: nightJobSearchTrigger,
            //       tooltip: "Batch triggers executions",
            //       onClick: (event, rowData) => {
            //         setTriggerExecution(true);
            //         dispatch(triggerExecutions(rowData?.groupCode));
            //         setHistoryData(rowData);
            //       },
            //     },
            //     {
            //       icon: () => (
            //         <>
            //           <Button
            //             type="button"
            //             variant="outlined"
            //             className={`search-btn`}
            //             disabled={roleDataDisable?.add === false}
            //           >
            //             Add Batch Trigger
            //           </Button>
            //         </>
            //       ),
            //       disabled: roleDataDisable?.add === false,
            //       hidden: nightJobSearchTrigger,
            //       isFreeAction: true,
            //       onClick: () => setValue(1),
            //     },
            //   ]
            // }
            actions={
              !nightJobSearchTrigger && [
                {
                  icon: () => <SaveIcon />,
                  tooltip: 'Save User',
                  onClick: (event, rowData) => console.log(rowData, 'rowData'),
                },
              ]
            }
          />
        </div>
      </Grid>
      {/* {isLoading && <PageLoader />} */}
      {loading && <PageLoader />}
      {(deleteErrorMsg || errorMsg) && <ErrorSnackbar errorMsg={deleteErrorMsg || errorMsg} />}
      {(tstmsg || successMsg) && <SuccessSnackbar successMsg={tstmsg || successMsg} />}
    </>
  );
}
